import { EntityView } from '@/common/entityFramework/entityView/EntityView';
import { Route } from 'react-router-dom';
import { UcbInctvLedgerDashboard } from '../../entities/inctvLedgerDashboard/UcbInctvLedgerDashboard';
import { FeesForecastDashboard } from './entities/dsaForecast/FeesForecastDashboard';
import { McoPhsCapDashboard } from './entities/mcoInv/phsCapDashboard/McoPhsCapDashboard';

const ucbScRoutes = [
  <Route path="/sc/dashboard/inctv-ledger" element={<UcbInctvLedgerDashboard />} />,
  <Route path="/sc/dashboard/fees-forecast" element={<FeesForecastDashboard />} />,
  <Route path="/sc/mco-phs-cap-dashboard" element={<McoPhsCapDashboard />} />,
  <Route path="/sc/mcd-ledger-line" element={<EntityView />} />,
];

export default ucbScRoutes;
